import React, { useState, useEffect } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./CashMovement.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form, Row, Col, Container, Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { FaTrash, FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"
import { MdAdd } from "react-icons/md";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";






const CashMovement = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [show1, setShow1] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [file, setFile] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState();
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState();
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState();
  const [phone, setPhone] = useState();
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [foundCashUUID, setFoundCashUUID] = useState("");
  const [cashID, setCashID] = useState('');
  const [eyeClicked, setEyeClicked] = useState(false);
  const [selectedDate12, setSelectedDate12] = useState('');
  const [foundCashArrays, setFoundCashArrays] = useState([]);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [currentMonth, setCurrentMonth] = useState('');
  const [formData, setFormData] = useState([{ sn: 1, accountFrom: '',  accountTo: '', amount: '', description: '', }]);
  const [load, setLoad] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [tableDatas, setTableDatas] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptions1, setSelectedOptions1] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);

  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }

      if (current !== null) {
        const date = new Date(current);
      
        setCurrentMonth(date);
      
        // 1st and last days of that month
        const startOfDateRange = new Date(date.getFullYear(), date.getMonth(), 1);
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      
        console.log(
          'Date Range:',
          formatDate(startOfDateRange),
          'to',
          formatDate(endOfDateRange)
        );
      }



    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  

  const handleClose1 = () => setShow1(false);

const handleShow1 = (item) => {
  setSuppliers(item)
  setFullName1(item.name || "");
  setEmail1(item.email || "");
  setAddress1(item.address || "");
  setPhoneNo(item.phone_number || "");
  setShow1(true);
};

// const FetchSuppliers = async () => {
//   setBenLoading(true);
//   try {
//     const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
//     const results = response.data?.data;
//     const resultx = response.data?.data?.total;
//     setTableData(results);
//     const total = response.data?.data?.last_page || 1;
//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       navigate('/login');
//     } else {
//       let errorMessage = 'An error occurred. Please try again.';
//       if (error.response && error.response.data && error.response.data.message) {
//         if (typeof error.response.data.message === 'string') {
//           errorMessage = error.response.data.message;
//         } else if (Array.isArray(error.response.data.message)) {
//           errorMessage = error.response.data.message.join('; ');
//         } else if (typeof error.response.data.message === 'object') {
//           console.log(errorMessage);
//           setError(errorMessage)
//         }
//       }
//       setTableData([]);
//     }
//   } finally {
//     setBenLoading(false);
//   }
// };

// useEffect(() => {
//   if (bearer) {
//     FetchSuppliers();
//   }
// }, [bearer, currentPage]);

const fetchData = async () => {
  setBenLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/cash_movement`, { headers });
    const results = response.data?.data;
    // console.log(results, "movement");
    setTableData(results);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    }
  } finally {
    setBenLoading(false);
  }
};

useEffect(() => {
  if (bearer) {
    fetchData();
  }
}, [bearer, currentPage]);




const handleShow = () => setShow(true);
const handleClose = () => setShow(false);

    // const handleChange = (option) => {
    //         setSelectedOption(option);
    //         console.log("Selected:", option);
    //     };
    function getLoanColors(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 90%)`, 
    color: `hsl(${hue}, 70%, 30%)`,   
  };
}


  const [rows, setRows] = useState([{ bankName: "", accName: "", accNo: "" }]);

  const addRow = () => {
    const newRow = {
      sn: formData.length + 1,
      accountTo: '',
      accountFrom: '',
      amount: '',
      description: '',
     
    };

    setFormData([...formData, newRow]);
  };

  const deleteRow = (index) => {
    const updatedData = formData.filter((_, i) => i !== index);
    setFormData(updatedData);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

const handleUploadShow = () => setUploadShow(true);
const handleUploadClose = () => {
  setUploadShow(false);
  setFile(null);
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  setFile(file);
};


const updateBeneficiary = async () => {

  setUploadLoading(true);
  try {
    const bankAccounts = rows.map(item => item.accNo);
    const accountNames = rows.map(item => item.accName);
    const bankNames = rows.map(item => item.bankName);

    const response = await axios.post(`${BASE_URL}/beneficiaryaccounts/update`,
      {
        name: fullName1,
        email: email1,
        phone_number: phoneNo,
        address: address1,
        bank_account: bankAccounts,
        account_name: accountNames,
        bank_name: bankNames,
        id: suppliers.id
       
      },
      { headers }
    );
    handleClose1();
    // FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    })
    // .then(() => {
    //   window.location.reload();
    // });
    console.log(response.data.message)
    setUploadLoading(false);
} catch (error) {
  let errorMessage = error.response?.data?.message;
  // let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log("error", errorMessage);
          }
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: errorMessage,
          });
      }
  } finally {
    setUploadLoading(false);
  }
};

const uploadExcelHandler = async () => {
  if (!file) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Please select a file to upload',
    });
    return;
  }

    // Confirmation alert before upload
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this file?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel",
    });
  
    if (!result.isConfirmed) {
      handleUploadClose(); 
      return; 
    }

  setUploadLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${BASE_URL}/beneficiary/upload`, 
      formData, 
      { headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        } });

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message || 'File uploaded successfully',
    });
    window.location.reload();

    handleUploadClose();
    setFile("");
  } catch (error) {
    let errorMessage;

    if (error.response && error.response.data) {
      errorMessage = typeof error.response.data.message === 'object'
        ? JSON.stringify(error.response.data.message)
        : error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unexpected error occurred while uploading the file';
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setUploadLoading(false);
  }
};

const createBeneficiary = async () => {
  setLoading(true);
  try {
    const response = await axios.post(`${BASE_URL}/beneficiary/add`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankName,
        account_name: accName,
        account_number: accNo
      },
      { headers }
    );
    console.log(response.data.message);
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    // FetchSuppliers();
    handleClose();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data.message);

  } catch (error) {
    let errorMessage;

    // Attempt to extract the error message
    if (error.response && error.response.data) {
      // If message is an object, attempt to stringify it
      if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      } else {
        errorMessage = error.response.data.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "An unexpected error occurred";
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 //delete function
 const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this member.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setUploadLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/beneficiary/delete?id=${id}`, { headers });
    // FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
   
    setUploadLoading(false);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      // toast.error(errorMessage)
      console.log(errorMessage);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  }
  finally {
    setUploadLoading(false); // always stop uploading, success or fail
  }
};


const filteredData = tableData.filter(item => item.description.toLowerCase().includes(searchTerm.toLowerCase()));

const totalPages = Math.ceil(filteredData.length / entriesPerPage);

const handlePrevPage = () => {
  setCurrentPage(Math.max(currentPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(Math.min(currentPage + 1, totalPages));
};

const totalEntries = filteredData.length;
const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);

const handleDateChange = (e) => {
  const newDate = e.target.value;

  // Ensure minDate and maxDate are set
  if (!minDate || !maxDate) return;

  // Block if outside range
  if (newDate < minDate || newDate > maxDate) {
    alert(`Please select a date between ${minDate} and ${maxDate}`);
    return;
  }

  setSelectedDate(newDate);
};

const fetchCharts = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/account`, { headers });
    const results = response.data?.data;

    const options = results.map((chart) => ({
      label: `${chart.gl_code} - ${chart.gl_name}`,
      value: chart.id,
    }));
    

    setTableDatas(results);
    setSelectOptions(options);
  } catch (error) {
    if (error.response && error.response.status === 401) {

      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setSelectOptions([]);
    }
  } finally {
    setIsLoading(false);
  }
};


useEffect(() => {
  if (bearer) {
    fetchCharts();

  }
}, [bearer]);

const handleAccountChange = (selectedOption, rowIndex) => {
  setSelectedOptions((prevOptions) => {
    const updatedOptions = [...prevOptions];
    updatedOptions[rowIndex] = selectedOption;
    return updatedOptions;
  });

  const selectedChart = tableDatas.find((chart) => chart.id === selectedOption.value);

  if (selectedChart) {
    const updatedFormData = [...formData];
    updatedFormData[rowIndex].accountFrom = selectedChart.id;
    setFormData(updatedFormData);
  }
};

const handleAccountChange1 = (selectedOption, rowIndex) => {
  setSelectedOptions1((prevOptions) => {
    const updatedOptions = [...prevOptions];
    updatedOptions[rowIndex] = selectedOption;
    return updatedOptions;
  });

  const selectedChart1 = tableDatas.find((chart) => chart.id === selectedOption.value);

  if (selectedChart1) {
    const updatedFormData = [...formData];
    updatedFormData[rowIndex].accountTo = selectedChart1.id;
    setFormData(updatedFormData);
  }
};

const handleFormChange = (index, field, value) => {
  let formattedValue = value;

  // Format the amount field
  if (field === 'amount' && value !== '') {
    formattedValue = (Number(value.replace(/\D/g, '')) || '').toLocaleString();
  }

  const updatedFormData = [...formData];
  updatedFormData[index][field] = formattedValue;
  setFormData(updatedFormData);
};

const handleValueChange1 = (value, index) => {
  const updatedFormData = [...formData];
  updatedFormData[index] = {
    ...updatedFormData[index],
    amount: value,
  };
  setFormData(updatedFormData);
};


const handleViews = (id) => {

  const foundCash = tableData.find(item => item.id === id);
  const cashId = foundCash.id;
  const cashUUID = foundCash.uuid;
  setCashID(cashId);
  setFoundCashUUID(cashUUID);
  const foundCashArray = foundCash ? [foundCash] : [];
  setFoundCashArrays(foundCashArray);

  const {transaction_date  } = foundCash;
  setSelectedDate12(transaction_date || '');


  setShow1(true);
  setEyeClicked(true);
};

const createJournals = async () => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to reverse this transaction.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, reverse it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return;
  }
  
  setLoad(true);

  try {
    const response = await axios.post(`${BASE_URL}/cash_movement/reversal`,
      {
       uuid: foundCashUUID
      },
      { headers }
    );
   

    Swal.fire({
      icon: 'success',
      title: 'Successful',
      text: response.data.message,
    });
    navigate(-1);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
      
        console.log(errorMessage);
      }
    }
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: JSON.stringify(error.response.data.message),
    });
    //   console.log(error);
  } finally {
    setLoad(false);
  }
};

  const createJournal = async () => {
      const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You are about to process this transaction.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, process it!',
        cancelButtonText: 'No, cancel',
      });
  
      if (!confirmed.isConfirmed) {
        return;
      }
      
      setLoad(true);
  
      try {
        const accountFrom = formData.map((row) => row.accountFrom).filter((name) => name !== undefined);
        const accountTo = formData.map((row) => row.accountTo).filter((name) => name !== undefined);
        const descriptions = formData.map((row) => row.description).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((name) => name !== undefined);
        // const debitAmount = totalAmountDebit.replace(/,/g, '').replace(/\.00$/, '');
  
  
  
        // console.log(accountNames, creditAmount, debitAmount, descriptions, amounts, directions, "information")
        const response = await axios.post(`${BASE_URL}/cash_movement/create`,
          {
           transaction_date: selectedDate,
           from: accountFrom,
           to: accountTo,
           description: descriptions,
           amount: amounts
          },
          { headers }
        );
      
  
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message,
        }).then(() => {
          window.location.reload(); 
        });
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
          
            console.log(errorMessage);
          }
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        //   console.log(error);
      } finally {
        setLoad(false);
      }
    };


        
  return (
    <div >
        <HeaderNav />
      
    
{/* <Modal show={show1} onHide={handleClose1} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update Suppliers</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Name"
          value={fullName1}
          onChange={(e) => setFullName1(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Email</Form.Label>
        <Form.Control
          type="text"
          placeholder="Email"
          value={email1}
          onChange={(e) => setEmail1(e.target.value)}
        />
        </Col>
      </Row>

      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
        <Form.Control
          type="text"
          placeholder="Phone Number"
          value={phoneNo}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Address</Form.Label>
      <Form.Control
          type="text"
          placeholder="Phone Number"
          value={address1}
          onChange={(e) => setAddress1(e.target.value)}
        />
        </Col>
      </Row>
        
      </Form.Group>
      <Form.Group>
      <Container fluid style={{marginTop: "40px"}} className={classes.wrapper}>
      <h6 className={classes.headerText} style={{textAlign: "left"}}>Add Bank Accounts</h6>

      <div className="table-responsive">
      <table className={classes.customtable}>
        <thead>
          <tr>
            <th>Bank Name</th>
            <th>Account Name</th>
            <th>Account Number</th>
            <th style={{backgroundColor: "unset"}} className="text-center">
              <button style={{backgroundColor: "unset"}} className={classes.plusbtn} onClick={addRow}>
              <FaPlus
              size={12}
              color="white"
              style={{ cursor: "pointer" }}
            />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Control
                  type="text"
                  value={row.bankName}
                  onChange={(e) =>
                    handleChange(index, "bankName", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.accName}
                  onChange={(e) =>
                    handleChange(index, "accName", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.accNo}
                  onChange={(e) =>
                    handleChange(index, "accNo", e.target.value)
                  }
                />
              </td>
              <td className="text-center">
                <button style={{backgroundColor: "unset"}} className={classes.btntrash} onClick={() => deleteRow(index)}>
                <img src={DeleteIcon}/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </Container>
      </Form.Group>
 
    </Form>
  </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={updateBeneficiary}>
     Update Benficiary
    </Button>

  </Modal.Footer>
</Modal> */}

{/* <Modal show={uploadShow} onHide={handleUploadClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Excel File</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{padding: 0}}>
                <Form style={{ marginTop: 5 }}>
               
                  <Form.Group style={{padding: 10,}}>
                
                </Form.Group>
                  <Form.Group style={{padding: 10}} className="mb-3" controlId="exampleForm.ControlInput2">
                    <Form.Label>Select Excel File</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                    <div style={{ marginTop: 10 }} />
                  </Form.Group>

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleUploadClose}>
                  Go back
                </Button>
                <Button  className={classes.customButton}  onClick={uploadExcelHandler}>
                  Upload File
                </Button>
              
              </Modal.Footer>
            </Modal> */}

            <Modal size='xl' show={show} onHide={handleClose} animation={false} >
                <Modal.Header closeButton>
                  <Modal.Title>Cash Movement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form >
                  <div  style={{marginTop: 10}}>
                  <Row className="justify-content-left">
        <Col md={3}>
          <Form>
            <Form.Group controlId="transactionDate">
              <Form.Label className="mb-2">Transaction Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Enter transaction date"
                className="mb-3"
                onChange={handleDateChange}
                value={selectedDate}
                min={minDate}
                max={maxDate} 
              />
            </Form.Group>
          </Form>
        </Col>
      </Row>
                
</div>
<div style={{ marginTop: 20 }} />
<div className="table-responsive">
                              <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                                  <thead className={classes.tableHeader} style={{ whiteSpace: "nowrap", textAlign: "center", alignItems: "center", backgroundColor: "#174384", color: "#fff" }}>
                                  <tr>
                                    {/* <th>#</th> */}
                                    {/* <th style={{ width: '15%', }}>Transaction Date</th> */}
                                    <th style={{ width: '28%', }}>From Account</th>
                                    <th style={{ width: '28%', }}>To Account</th>
                                    <th style={{ width: '25%', }}>Description</th>
                                    {/* <th style={{ width: '15%', }}>DR/CR</th> */}
                                    <th style={{ width: '19%', textAlign: "right" }}>Amount</th>
                                    {/* <th style={{ width: '15%', }}>Cheque/Teller Number</th> */}

                                    <th >
                                    <OverlayTrigger
                                      placement="top"
                                      className={classes.btndf1}
                                      overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to add new row</Tooltip>}
                                    >
                                      <Button  onClick={() => addRow()} style={{ fontSize: "16px", backgroundColor: "unset", border: "none", fontWeight: "700" }}>
                                      {/* <i className="fas fa-plus"></i> */} +
                                    </Button>
                                    </OverlayTrigger>
                                    </th>

                                  </tr>
                                </thead>
                                <tbody style={{ whiteSpace: "nowrap", textAlign: "center", alignItems: "center" }}>
                                  {formData.map((row, index) => (
                                    <tr key={index}>
                                      {/* <td>{row.sn}</td> */}
                                      {/* <td>
                                        <input
                                          value={row.date}
                                          onChange={(e) => handleFormChange(index, 'date', e.target.value)}
                                          className="form-control"
                                          type="date"
                                          min={minDate}
                                          max={maxDate}                        
                                        />
                                      </td> */}
                                      <td >
                                        <Select
                                          value={selectedOptions[index]}
                                          onChange={(selectedOption) => handleAccountChange(selectedOption, index)}
                                          options={selectOptions}
                                          menuPortalTarget={document.body}
                                          styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (provided) => ({
                                              ...provided,
                                              // maxHeight: '200px', 
                                              // overflowY: 'auto',
                                            }),
                                          }}
                                        />

                                      </td>
                                      <td >
                                        <Select
                                          value={selectedOptions1[index]}
                                          onChange={(selectedOption) => handleAccountChange1(selectedOption, index)}
                                          options={selectOptions}
                                          menuPortalTarget={document.body}
                                          styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (provided) => ({
                                              ...provided,
                                              // maxHeight: '200px', 
                                              // overflowY: 'auto',
                                            }),
                                          }}
                                        />

                                      </td>
                                      <td>
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          rows={1}
                                          value={row.description}
                                          onChange={(e) => handleFormChange(index, 'description', e.target.value)}
                                        />
                                      </td>
                                      {/* <td>
                                        <Form.Select
                                          value={row.DR_CR}
                                          onChange={(e) => handleFormChange(index, 'DR_CR', e.target.value)}
                                          className="form-control"
                                        >
                                          <option value="">Select</option>
                                          <option value="1">DR</option>
                                          <option value="2">CR</option>
                                        </Form.Select>
                                      </td> */}
                                      <td>
                                        <CurrencyInput
                                          name={`rowAmount ${index}`} // Provide a unique name for each CurrencyInput
                                          decimalsLimit={2}
                                          value={row.amount}
                                          className="form-control"
                                          onValueChange={(value) => handleValueChange1(value, index)}
                                          style={{ textAlign: "right", border: "none" }}
                                        />
                                        {/* <input
                                                type="text"
                                                className="form-control"
                                                value={row.amount}
                                                onChange={(e) => handleFormChange(index, 'amount', e.target.value)}
                                                style={{ textAlign: "right" }}
                                              /> */}
                                      </td>
                                      {/* <td>
                                        <input
                                          value={row.cheque}
                                          onChange={(e) => handleFormChange(index, 'cheque', e.target.value)}
                                          className="form-control"
                                          type="text"
                                        />
                                      </td> */}


                                      <td style={{ textAlign: "left" }}>
                                      <OverlayTrigger
                                        placement="top"
                                        className={classes.btndf1}
                                        overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to delete row</Tooltip>}
                                      >
                                        <Button onClick={() => deleteRow(index)} style={{backgroundColor: "unset", border: "none"}}>
                                          {/* <i className="far fa-trash-alt"></i> */}
                                          <img src={DeleteIcon} />
                                        </Button>
                                      </OverlayTrigger>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                            </div>
                  </Form>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="danger" onClick={handleClose}>
                    Go back
                  </Button>
                  <Button
                          className={classes.longbtn}
                            variant='success'
                            onClick={createJournal}
                            // disabled={!isEqual}
                            style={{ padding: '5px 30px', backgroundColor: "#092147"}}>
                            {load ? (
                              <>
                                <Spinner size='sm' />
                                <span style={{ marginLeft: '5px' }}>Saving, Please wait...</span>
                              </>
                            ) : (
                              "Save"
                            )}
                          </Button>
                </Modal.Footer>
              </Modal>

            <Modal size='xl' show={show1} onHide={handleClose1} animation={false}>
                <Modal.Header closeButton>
                  <Modal.Title>Cash Movement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form >
                  <div  style={{marginTop: 10}}>
                  <Row className="justify-content-left">
        <Col md={6}>
          <Form>
            <Form.Group controlId="transactionDate">
              <Form.Label className="mb-2">Transaction Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Enter transaction date"
                className="mb-3"
               
                                     value={selectedDate12}
                                     min={minDate}
                                     max={maxDate} 
              />
            </Form.Group>
          </Form>
        </Col>
      </Row>
                
</div>
<div style={{ marginTop: 20 }} />
<div className="table-responsive">
                              <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                                  <thead className={classes.tableHeader} style={{ whiteSpace: "nowrap", textAlign: "center", alignItems: "center" }}>
                                  <tr>
                                    <th>#</th>
                                    {/* <th style={{ width: '15%', }}>Transaction Date</th> */}
                                    <th style={{ width: '26%', }}>From Account</th>
                                    <th style={{ width: '26%', }}>To Account</th>
                                    <th style={{ width: '30%', }}>Description</th>
                                    {/* <th style={{ width: '15%', }}>DR/CR</th> */}
                                    <th style={{ width: '18%', textAlign: "right" }}>Amount</th>
                                    {/* <th style={{ width: '15%', }}>Cheque/Teller Number</th> */}

                                    {/* <th >
                                    <OverlayTrigger
                                      placement="top"
                                      className={classes.btndf1}
                                      overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to add new row</Tooltip>}
                                    >
                                      <Button variant="primary" onClick={() => addRow()} style={{ borderRadius: "50px" }}>
                                      <i className="fas fa-plus"></i>
                                    </Button>
                                    </OverlayTrigger>
                                    </th> */}

                                  </tr>
                                </thead>
                                <tbody style={{ whiteSpace: "nowrap", textAlign: "center", alignItems: "center" }}>
                                  {foundCashArrays.map((row, index) => (
                                    <tr key={index}>
                                      <td>{row.sn}</td>
                                      {/* <td>
                                        <input
                                          value={row.date}
                                          onChange={(e) => handleFormChange(index, 'date', e.target.value)}
                                          className="form-control"
                                          type="date"
                                          min={minDate}
                                          max={maxDate}                        
                                        />
                                      </td> */}
                                      <td >
                                      {row?.from_account?.gl_name}
                                        {/* <Select
                                          value={selectedOptions[index]}
                                          onChange={(selectedOption) => handleAccountChange(selectedOption, index)}
                                          options={selectOptions}
                                          menuPortalTarget={document.body}
                                          styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (provided) => ({
                                              ...provided,
                                              // maxHeight: '200px', 
                                              // overflowY: 'auto',
                                            }),
                                          }}
                                        /> */}

                                      </td>
                                      <td >
                                      {row?.to_account?.gl_name}
                                        {/* <Select
                                          value={selectedOptions1[index]}
                                          onChange={(selectedOption) => handleAccountChange1(selectedOption, index)}
                                          options={selectOptions}
                                          menuPortalTarget={document.body}
                                          styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (provided) => ({
                                              ...provided,
                                              // maxHeight: '200px', 
                                              // overflowY: 'auto',
                                            }),
                                          }}
                                        /> */}

                                      </td>
                                      <td>
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          rows={1}
                                          value={row.description}
                                          disabled
                                          onChange={(e) => handleFormChange(index, 'description', e.target.value)}
                                        />
                                      </td>
                                      {/* <td>
                                        <Form.Select
                                          value={row.DR_CR}
                                          onChange={(e) => handleFormChange(index, 'DR_CR', e.target.value)}
                                          className="form-control"
                                        >
                                          <option value="">Select</option>
                                          <option value="1">DR</option>
                                          <option value="2">CR</option>
                                        </Form.Select>
                                      </td> */}
                                      <td>
                                        <CurrencyInput
                                          name={`rowAmount ${index}`} // Provide a unique name for each CurrencyInput
                                          decimalsLimit={2}
                                          value={row.amount}
                                          disabled
                                          className="form-control"
                                          onValueChange={(value) => handleValueChange1(value, index)}
                                          style={{ textAlign: "right", border: "none" }}
                                        />
                                        {/* <input
                                                type="text"
                                                className="form-control"
                                                value={row.amount}
                                                onChange={(e) => handleFormChange(index, 'amount', e.target.value)}
                                                style={{ textAlign: "right" }}
                                              /> */}
                                      </td>
                                      {/* <td>
                                        <input
                                          value={row.cheque}
                                          onChange={(e) => handleFormChange(index, 'cheque', e.target.value)}
                                          className="form-control"
                                          type="text"
                                        />
                                      </td> */}


                                      {/* <td style={{ textAlign: "left" }}>
                                      <OverlayTrigger
                                        placement="top"
                                        className={classes.btndf1}
                                        overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to delete row</Tooltip>}
                                      >
                                        <Button variant="danger" onClick={() => deleteRow(index)} style={{ borderRadius: "50px" }}>
                                          <i className="far fa-trash-alt"></i>
                                        </Button>
                                      </OverlayTrigger>
                                      </td> */}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                            </div>
                  </Form>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="danger" onClick={handleClose}>
                    Go back
                  </Button>
                  <Button
                          className={classes.longbtn}
                            variant='success'
                            onClick={createJournals}
                            // disabled={!isEqual}
                            style={{ padding: '5px 30px', backgroundColor: "#092147" }}>
                            {load ? (
                              <>
                                <Spinner size='sm' />
                                <span style={{ marginLeft: '5px' }}>Reversing, Please wait...</span>
                              </>
                            ) : (
                              "Reverse"
                            )}
                          </Button>
                </Modal.Footer>
              </Modal>


            {uploadLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}

            {/* <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Supplier/Contractor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form style={{ marginTop: 20 }}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Bank Name"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Account Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Account Name"
                  value={accName}
                  onChange={(e) => setAccName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Account Number"
                  value={accNo}
                  onChange={(e) => setAccNo(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Go back
            </Button>
            <Button className={classes.customButton} onClick={createBeneficiary}>
              Create Beneficiary
            </Button>
          </Modal.Footer>
        </Modal> */}
        {loading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Receipts</Button>
            <Button className={classes.buttonsNav}>Payments</Button>
          </div>
          <div style={{}}/>
            <h3 className={classes.topText}>Cash Movement</h3>
            <p className={classes.prgText}>View Cash Movement.</p>
            <div className={classes.subContainer}>
               
                           
                            <div style={{marginLeft: "6px", display: "flex", gap: "20px"}}>
                            <button className={classes.loanBtn} 
                            // onClick={handleShow}
                            onClick={handleShow}
                            >
                              <img src={plus} alt="plus" /> 
                              Add New
                            </button>

                            {/* <button className={classes.loanBtn} 
                          onClick={handleUploadShow}
                          >
                            Upload Excel
                          </button> */}

                            {/* <button  className={classes.customButton1} >
                            <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                            <img src={download} alt="download" /> Download Template
                              </a>
                          </button>  */}
                          </div>

                          {/* <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Suppliers Accounts</p>
                              <p className={classes.txtHds}>{formattedTotalEntries}</p>
                              </div>
                            </div> */}

                         <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>

            </div>
            
            <div className={classes.tableContainer}>
            
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
                             <tr style={{fontSize: "12px"}}>
                             <th>S/N</th>
                          <th>UUID</th>
                          <th>Transaction Date</th>
                          <th>Description</th>
                          <th>From Account</th>
                          <th>To Account</th>
                          <th style={{textAlign: "right"}}>Total Amount</th>
                          <th>Actions</th>
                            </tr>
  </thead>
  <tbody>

  { benLoading ? (
    searchTerm ? (
      <tr>
        <td colSpan={5} style={{ textAlign: "center" }}>
          Fetching Suppliers...
        </td>
      </tr>
    ) : (
      Array(8).fill().map((_, idx) => (
        <tr key={idx}>
          {Array(8).fill().map((_, i) => (
            <td key={i}>
              <Skeleton height={20} style={{ marginBottom: 10 }} />
            </td>
          ))}
        </tr>
      ))
    )
  ) : (
    displayedData.map((item, index) => (
                          <tr key={index} style={{fontSize: "12px", fontWeight: "400", color: "#092147"}}>
                            <td>{index + 1}</td>
                            <td style={{ whiteSpace: 'wrap',  }}>{item.uuid}</td>
                            <td style={{ textAlign: "left" }}>{item.transaction_date}</td>
                            <td  style={{ whiteSpace: 'wrap', }}>{item.description}</td>
                            <td style={{ whiteSpace: 'wrap',  }}>{item.from_account?.gl_name}</td>
                            <td style={{ whiteSpace: 'wrap',  }}>{item.to_account?.gl_name}</td>
                           
                            {/* <td style={{textAlign: "right"}}>{parseFloat(item?.total_debit).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}</td> */}
                            <td style={{textAlign: "right"}}>{parseFloat(item?.amount).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}</td>
                                         {/* <td>{formatDate(item.created_at)}</td> */}
                            <td >
                              <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
                                  {/* <div
                                    onClick={() => handleTrashClick(item.uuid)}
                                    
                                    style={{ padding: '0 10px', cursor: "pointer", }}
                                  >
                                    <MdOutlineRestorePage fontSize={20} style={{color: "#2D995F", }} />
                                  </div> */}
                                  <div   
                                  onClick={() => handleViews(item.id)}  
                                  // className="mr-1 btn btn-success-soft btn-sm"
                                  >
                                  <img src={EyeIcon} />
                                                                            </div>
                                  {/* <div   onClick={() => handleTrashClick12(item.uuid)}  className="mr-1 btn btn-danger-soft btn-sm">
                                                                                <i className="far fa-trash-alt" style={{ color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12 }}></i>
                                                                            </div> */}
                                  </div> 

                            
                            </td>
                          </tr>
    ))
  )
}
  </tbody>
  {!benLoading && searchTerm && displayedData.length === 0 && (
  <tbody>
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}>
        No Suppliers found
      </td>
    </tr>
  </tbody>
)}

</table>

{!benLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${startIndexx}  - ${endIndexx} pages`} of {totalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default CashMovement